import { render, staticRenderFns } from "./drawerCallInfo.vue?vue&type=template&id=23bee393&scoped=true&"
import script from "./drawerCallInfo.vue?vue&type=script&lang=js&"
export * from "./drawerCallInfo.vue?vue&type=script&lang=js&"
import style0 from "./drawerCallInfo.vue?vue&type=style&index=0&id=23bee393&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "23bee393",
  null
  
)

export default component.exports